/*
 * @Author: 张印 hbzyin@163.com
 * @Date: 2023-07-18 09:09:19
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-12-20 10:57:29
 * @FilePath: /mall-fe/src/libs/cons.ts
 * @Description: 常量维护文件
 *
 */
// 中建三局
export const isCscec3bTenant = process.env.TARGET === 'cscec3b';
export const DEFAULT_TENEANT_AREA_COOKIE_KEY = 'TC00000030_area_sys_no';

// 轮播组件自动轮博时间
export const CAROUSEL_AUTOPLAY_SPEED = 3500;

// 商品数量最大值
export const MAX_QUANTITY = 99999999;

// 默认/失败 经纬度 北京市丰台区G4辅路
export const defaultCoordsStr = '116.279093,39.879342';

// 附件上传文件类型
export const ATTACHMENT_ACCEPT_TYPE = '.png,.jpg,.pdf,.jpeg,.doc,.docx,.xls,.xlsx';

// 文件类型不符提示文案
export const ATTACHMENT_ACCEPT_TIPS =
  '支持Excel、PDF、JPG、PNG、Word格式的文件，最多可上传10个，每个大小小于10M';

// 附件上传文件最大值
export const FILE_SINGLE_SIZE_LIMIT = 1024 * 1024 * 10;

// 发货单附件类型
export const FILE_DELIVERY_ACCEPT_TYPE = '.doc, .docx, .pdf, .jpg, .png, .jpeg, .xls, .xlsx';

export const RegexConstant = {
  /**
   * 0~1 两位小数
   */
  PercentDecimal: /^0(\.[0-9]{1,2})?$/,

  /**
   * -9999999999.9999~9999999999.9999 正整数
   */
  Price: /^[-]?[0-9]{0,10}(\.[0-9]{1,4})?$/,

  Decimal: /^[-]?[0-9]{1,10}(\.[0-9]{1,10})?$/,

  /**
   * 是否为数字：
   * true： "3", "-3", "0", "0.0", "1.0", "0.7", "690.7", "0.0001", "-555", "945465464654"
   * false: "a", "", " ", ".", "-", "001", "00.2", "000.5", ".3", "3.", " -1", "--1", "-.1", "-0", "00099", "099"
   */
  Number: /^(-?[1-9]+\d*([.]\d+)?)$|^(-?0[.]\d*[1-9]+)$|^0$|^0.0$/,

  Phone: /^1\d{10}$/,
};

export const idaasLoginUrl = 'https://idaas.zj31.net/frontend/login#/login';

// area cookie过期时间
export const AREA_COOKIE_EXPORES = 360;

// 默认 假的cookie
export const DEFAULT_COOKIE_AREASYSNO = 'areaSysNo_0000000';

// 三局严选公众号appid st ga 都用的这一个
export const CSCEC3B_APP_ID = 'wxd6b7eae80c28fa0d';

// 订单来源
export const ORDER_SOURCE = {
  SKU: 'sku',
  CART: 'cart',
};

/**
 * 有些页面不需要定位信息，也不想弹出请求位置信息的弹窗
 * 可以再 url 上 `contains` 一个特殊的 hash 来排除
 */
export const NO_LOC_HASH = 'no-loc';

// 竞价专区头部tab
export const tabs = [
  {
    key: '1',
    name: '求购需求',
  },
  {
    key: '2',
    name: '中标公告',
  },
];

// 商品在售状态
export const ProductBuyStatus = {
  Normal: 'canBuy',
  NotInArea: '该区域不可售',
  Removed: '商品已下架',
  SoldOut: '商品补货中',
  AgreementCanNotSale: '该商品不可售',
  NoInventory: '无货，此商品暂时售完',
  NoAgreement: '该商品不可售',
  SupplierLimitEnable: '供应商被限制交易',
  NoBasePrice: '该商品价格异常',
} as const;

// 是否开启赊销系统的key
export const ENABLE_SUPPLY_CHAIN = 'enableSupplyChain';

// 房源现状
export enum HOUSE_STATUS {
  applying = 1,
  traded,
}

// 房源现状集合
export const houseStatusList = [
  {
    label: '已申购',
    value: HOUSE_STATUS.applying,
  },
  {
    label: '已成交',
    value: HOUSE_STATUS.traded,
  },
];

export const ATTR_VALUE_TYPE = {
  RADIO: {
    value: 1,
    label: '单选',
  },
  CHECKBOX: {
    value: 2,
    label: '多选',
  },
};

export const MMU_DATA_TYPE = {
  TEXT: {
    value: 1,
    label: '文本',
  },
  FLOAT: {
    value: 2,
    label: '数值',
  },
  INT: {
    value: 3,
    label: '整数',
  },
};

export const QUOTE_MODE = {
  WITHOUT_TAX_TYPE: {
    value: 1,
    label: '不含税',
  },
  WITH_TAX_TYPE: {
    value: 2,
    label: '含税',
  },
};

export const ENQUIRY_STATUS = {
  WAIT_REPLY: {
    label: '待回复',
    value: 10,
    color: '#FFB500',
  },
  REPLIED: {
    label: '已回复',
    value: 20,
    color: '#00BF83',
  },
  INVALID: {
    value: -100,
    label: '已作废',
    color: '#FE3351',
  },
};

export const ENQUIRY_SETTLEMENT_TYPE_ENUM = {
  SEPARATE: {
    value: 1,
    label: '单结',
  },
  WEEK: {
    value: 2,
    label: '周结',
  },
  MONTH: {
    value: 3,
    label: '月度结算',
  },
};
